import PropTypes from 'prop-types';
import React, { Component } from 'react';
import utils from '../../utils/utilities.js';
import FormGroup from './FormGroup.jsx';

export default class TextField extends Component {

    static propTypes = {
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        classNames: PropTypes.string,
        label: PropTypes.any,
        hasError: PropTypes.any,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        inputAttributes: PropTypes.object
    }

    static defaultProps = {
        label: null,
        hasError: false,
        disabled: false,
        required: false,
        classNames: null
    }


    constructor(props) {
        super(props);

        this.fieldId = "textfield_" + utils.generateRandomHash();
    }

    render() {
        return (
            <FormGroup {...this.props} fieldId={this.fieldId}>
                <input
                    type="text"
                    id={this.id}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
                    {...this.props.inputAttributes}
                />
            </FormGroup>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/TextField.jsx